"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var nextInputID = function () {
  var count = 0;
  return function () {
    return "input-".concat(count++);
  };
}();
var _default = exports.default = nextInputID;
//# sourceMappingURL=nextInputID.js.map